import {
    SbBlokData,
    StoryblokComponent,
    storyblokEditable,
} from "@storyblok/react/rsc";
import cn from "clsx";
import React from "react";
import styles from "./MarketingTextCard.module.scss";

type MarketingTextCardProps = {
    cards: SbBlokData[];
    primaryCard?: boolean;
};

export const MarketingTextCard: React.FC<MarketingTextCardProps> = ({
    cards = [],
    primaryCard = false,
}) => {
    if (!cards.length) {
        return null;
    }

    return cards.map((blok) => (
        <div
            {...storyblokEditable(blok)}
            key={blok._uid}
            className={cn(styles["marketing-text-card"], {
                [styles["marketing-text-card--non-primary"]]: !primaryCard,
            })}
        >
            <StoryblokComponent blok={blok} />
        </div>
    ));
};
